<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
          <div class="block">
            <el-date-picker
              v-model="value2"
              type="datetimerange"
              align="right"
              format="yyyy-MM-dd hh:mm:ss"
              value-format="yyyy-MM-dd hh:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" @click="clickBtn()">查询</el-button>
          </div>
      </div>
      <el-table :data="dataList" border style="width: 100%;">
        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
        <el-table-column prop="victim" header-align="center" align="center" label="受害者ip">
        </el-table-column>
        <el-table-column prop="name" header-align="center" align="center" label="事件名称">
        </el-table-column>
        <el-table-column prop="srcGeoRegion" header-align="center" align="center" label="来源安全域">
        </el-table-column>
        <el-table-column prop="lastOccurrenceTime" header-align="center" align="center" label="最近发生时间">
        </el-table-column>
        <el-table-column prop="firstOccurrenceTime" header-align="center" align="center" label="首次发生时间">
        </el-table-column>
        <el-table-column prop="alarmCount" header-align="center" align="center" label="告警数">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'modularChild6',
  props: ['socUserName'],    
  data () {
    return {
      value1: '',
      value2: [],
      radio: 1,
      dataList: [],
      chartLoading: false,
      endTime: "",
      username: "",
      startTime: ""   
    }
  },
  methods: {
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      let params = {
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }     
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/queryMaliciousAttackWarning`, params)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {
            // let res = this.formatterData(data.data.data)
            // this.chartsi.setOption(this.optioni)
            this.dataList = data.data.data.records
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    formatterData(data) {
      return []
    }
  },
  mounted () {
    this.getTime();
  }
}
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>